import { useTally } from '../hooks/useTally.jsx'
import { useTallyI18n } from '../i18n/tally.js'

// Small, unobtrusive badge: shows "Offline" when disconnected and a
// "N to sync" pill while offline edits are waiting to be replayed. Hidden
// entirely when online and nothing is pending. Tapping it forces a sync.
export function SyncStatus() {
  const { online, pendingCount, syncNow } = useTally()
  const t = useTallyI18n()

  if (online && pendingCount === 0) return null

  const cls = `sync-badge${online ? ' syncing' : ' offline'}`
  const label = online
    ? `${pendingCount} ${t.sync.pending}`
    : (pendingCount > 0 ? `${t.sync.offline} · ${pendingCount}` : t.sync.offline)

  return (
    <button
      type="button"
      className={cls}
      onClick={() => syncNow?.()}
      title={online ? t.sync.syncing : t.sync.offline}
      aria-label={label}
    >
      {online ? (
        <svg className="sync-spinner" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
          <path d="M21 12a9 9 0 1 1-6.22-8.56" />
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M18.8 19.8 1 1m22 22-4.2-4.2" />
          <path d="M4.9 7.5A6 6 0 0 0 6 19h11a4 4 0 0 0 1.9-.5" />
          <path d="M8.5 4.2A6 6 0 0 1 18 9a4 4 0 0 1 2.4 7.2" />
        </svg>
      )}
      <span className="sync-badge-text">{label}</span>
    </button>
  )
}
